export default __webpack_public_path__ + "media/zurb/img/case-study-libdib/libdib-hero-2b461bab808d6686b1423bad4f2a7069.jpg";